import type {$Fetch} from "nitropack";

export const PasswordRepository = (client: $Fetch) => ({
    async resetPassword(email: string) {
        return await client('/v2/auth/forgot-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: { email }
        });
    },

    async changePassword(token: string, password: string, confirm_password: string) {
        return await client('/v2/auth/recover-password',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: {
                    token,
                    password,
                    confirm_password
                }
            });
    },

    async updatePassword(current_password: string, new_password: string) {
        return await client('/v2/auth/change-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: {
                current_password,
                new_password
            }
        });
    },
})
